import Icon from "@ant-design/icons";
import React from "react";

import { ACIconProps } from "./ACIconWrapper";

export default function TrendLevelIcon(props: ACIconProps) {
  return <Icon className="ac-icon" component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0553 8.04151C16.3482 7.74862 16.8231 7.74862 17.116 8.04151L20.5101 11.4356C20.803 11.7285 20.803 12.2034 20.5101 12.4963L17.116 15.8904C16.8231 16.1833 16.3482 16.1833 16.0553 15.8904C15.7624 15.5975 15.7624 15.1226 16.0553 14.8297L18.1691 12.716L4.36311 12.716C2.69874 12.7799 2.89257 11.2267 4.3585 11.3318L18.1691 11.216L16.0553 9.10217C15.7624 8.80928 15.7624 8.3344 16.0553 8.04151Z"
        fill="currentColor"
        fill-opacity="0.3"
      />
    </svg>
  );
};
